import { z } from "zod"

import { type Filter, FilterAnyArg, filters } from "./types"

export function queryFiltersToFilters(rawFilters: string[]): Filter[] {
  const parsedFilters: Filter[] = []
  const unsupportedFilters: string[] = []

  for (const rawFilter of rawFilters) {
    const rawFilterFunctions = decodeURIComponent(rawFilter)
      // Remove leading `[[` and trailing `]]`, and split on each function call `][`
      .replace(/(^\[\[)|(\]\]$)/g, "")
      .split("][")

    for (const rawFilterFunction of rawFilterFunctions) {
      // Parse the filter function (e.g. type(path, ...args)) as { apiType, path, rawArgs }
      // @see https://regex101.com/r/2QvDG5/6
      const match = rawFilterFunction.match(
        /^(?<apiType>[\w-]+(\.[\w-]+)*)\(\s*(?<path>[\w-]+(\.[\w-]+)*)\s*(,(?<rawArgs>.*))?\)$/,
      )

      if (
        !match ||
        !match.groups ||
        !match.groups["apiType"] ||
        !match.groups["path"]
      ) {
        console.warn(
          `Could not parse filter function: ${rawFilterFunction}, wrong format`,
        )
        continue
      }

      const { apiType, path, rawArgs } = match.groups
      const filter = filters.find((filter) => filter.apiType === apiType)

      if (!filter) {
        unsupportedFilters.push(apiType)
        continue
      }

      // Args are stringified as JSON values and comma separated, so we can parse them as a JSON array
      let parsedArgs: unknown = []
      if (rawArgs) {
        try {
          parsedArgs = JSON.parse(`[${rawArgs}]`)
        } catch (error) {
          console.warn(
            `Could not parse filter function: ${rawFilterFunction}, invalid JSON arguments:`,
            error,
          )
          parsedArgs = []
        }
      }
      const validatedArgs = z.array(FilterAnyArg).safeParse(parsedArgs)

      if (!validatedArgs.success) {
        console.warn(
          `Could not parse filter function: ${rawFilterFunction}, wrong arguments format`,
        )
        continue
      }

      const args = [path, ...validatedArgs.data]
      if (filter.args.length !== args.length) {
        console.warn(
          `Could not parse filter function: ${rawFilterFunction}, wrong number of arguments`,
        )
        continue
      }

      parsedFilters.push({ type: filter.type, args } as Filter)
    }
  }

  if (unsupportedFilters.length > 0) {
    window.alert(
      `The following filters from the Document API are not yet supported in the API Explorer and will be ignored: ${unsupportedFilters.join(", ")}`,
    )
  }

  return parsedFilters
}
